import { DatePermissionParams } from "../../services/api/types/Dashboards";
import { Api } from "../../services/api";

interface Props {
  dateRange: DatePermissionParams;
}

export function useDashboardData({ dateRange }: Props) {
  const { data: checkIns, isLoading: isLoadingCheckIns } =
    Api.executiveDashboard.getCheckIns(dateRange);
  const { data: overtimeWeeks, isLoading: isLoadingOvertimeWeeks } =
    Api.executiveDashboard.getOvertimeWeeks(dateRange);
  const { data: timeOff, isLoading: isLoadingTimeOff } =
    Api.executiveDashboard.getTimeOff(dateRange);
  const { data: leaderScore, isLoading: isLoadingLeaderScore } =
    Api.executiveDashboard.getLeaderScores(dateRange);
  const { data: averageTicket, isLoading: isLoadingAverageTicket } =
    Api.executiveDashboard.getAverageTicket(dateRange);
  const { data: averageComp, isLoading: isLoadingAverageComp } =
    Api.executiveDashboard.getAverageComp(dateRange);
  const { data: teams, isLoading: isLoadingTeams } =
    Api.executiveDashboard.getTeams(dateRange);

  return {
    checkIns,
    isLoadingCheckIns,
    overtimeWeeks,
    isLoadingOvertimeWeeks,
    timeOff,
    isLoadingTimeOff,
    leaderScore,
    isLoadingLeaderScore,
    averageTicket,
    isLoadingAverageTicket,
    averageComp,
    isLoadingAverageComp,
    teams,
    isLoadingTeams,
  };
}
